import React, {Component} from "react";
import { observer } from "mobx-react";
import { fn_commonLeftNextPage, fn_commonLeftPrevPage, } from "../../../function/FnPage";

@observer
class OrderMenuLeftPagingBottomView extends Component {

    render() {

        const { rootStore } = this.props;
        const pageStore = rootStore.pageStore;

        return (
            <div className="paging_menu">
                <button type="button" className="prev"
                        disabled={pageStore.getLeftPagingInfo.page_no === 1 ? "disabled" : ""}
                        onClick={(event)=>fn_commonLeftPrevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{pageStore.getLeftPagingInfo.page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {pageStore.getLeftPagingInfo.max_page}
                </p>
                <button type="button" className="next"
                        disabled={pageStore.getLeftPagingInfo.page_no === pageStore.getLeftPagingInfo.max_page ? "disabled" : ""}
                        onClick={(event)=>fn_commonLeftNextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default OrderMenuLeftPagingBottomView;